import { createRoot } from 'react-dom/client'
import { Player, PlayerConfig } from '@/player/Player'

function mountPlayers() {
  document.querySelectorAll<HTMLElement>('[data-zoundbites-player]').forEach((el) => {
    if (el.dataset.mounted) return
    el.dataset.mounted = 'true'

    const config: PlayerConfig = {
      src: el.dataset.src!,
      title: el.dataset.title || 'Untitled',
      author: el.dataset.author || '',
      authorUrl: el.dataset.authorUrl || undefined,
      playUrl: el.dataset.playUrl || undefined,
      downloadUrl: el.dataset.downloadUrl || undefined,
      duration: Number(el.dataset.duration || 0),
      waveform: el.dataset.waveform ? JSON.parse(el.dataset.waveform) : [],
      compact: el.dataset.compact === 'true',
    }

    createRoot(el).render(<Player config={config} />)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountPlayers)
} else {
  mountPlayers()
}
